<template>
	<div id="app">
		<nav-bar></nav-bar>
		<keep-alive :include="cachedPages">
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>

	</div>
</template>

<script>
	import NavBar from "@/view/homeComponents/navBar.vue";
	// import ContactFooter from "@/view/homeComponents/banner.vue";

	export default {
		name: 'App',
		// name: 'app', //ycr 250621
		components: {
			// ContactFooter,
			NavBar
		},
		computed: {
			// 缓存指定名称的页面（需与组件name匹配）
			cachedPages() {
				return ['CompanyNewsList','SupplyServices','SupplyCenter','ExpertResources','EnterpriseServiceProviders','ScientificInstitutions','PolicyType']
			}
		}
	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		//margin-top: 60px;
	}
</style>